import theme, { createStyles,ThemeColors } from 'core/utilities/theme';

export default createStyles({
  color: {
    display: 'inline-block',
    marginRight: '8px',
    width: '16px',
    height: '16px',
    borderRadius: '3px',
    verticalAlign: 'middle',
  },
  popper: {
    zIndex: theme.zIndex.modal + 1,
    '& .sketch-picker': {
      border: `1px solid ${ThemeColors.darkBorderColor}`,
      boxShadow: 1,
    },
  },
  coverInsideModal: {
    position: 'fixed',
    zIndex: 1,
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
  },
  coverOutsideModal: {
    position: 'fixed',
    zIndex: theme.zIndex.modal - 1,
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
  },
});
